<template>
  <v-dialog v-model="dialog" :overlay="false">
    <v-card>
      <v-card-title>
        <div class="headline">Modifica prezzo principale</div>
      </v-card-title>
      <v-card-text>
        <v-text-field
          prepend-icon="euro_symbol"
          label="Prezzo"
          hint="Usare il punto per indicare i decimali"
          v-model="prezzo"
          @focus="parse"
          @blur="format"
        ></v-text-field>
      </v-card-text>
      <v-card-actions>
        <v-spacer></v-spacer>
        <v-btn flat primary @click.native="close">Annulla</v-btn>
        <v-btn flat primary @click.native="save">Salva</v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
/**
 * Cambio rapido del prezzo di un oggetto tramite dialog
 * @module components/common/MainPriceChanger
 */
export default {
  name: 'mainPriceChanger',
  data() {
    return {
      edited: null,
      prezzo: null
    }
  },
  methods: {
    close() {
      this.$emit('close', null)
    },
    save() {
      this.$emit('close', utils.toNumeral(this.prezzo).convert())
    },
    parse() {
      this.prezzo = utils.toNumeral(this.prezzo).convert()
    },
    format() {
      this.prezzo = utils.toNumeral(this.prezzo).toShow()
    }
  },
  watch: {
    editing(newV) {
      this.edited = newV != null ? utils.clone(newV) : null
      if (this.edited) {
        this.prezzo = utils.toNumeral(utils.getMainPrezzo(this.edited, this.listino, this.type).prezzo).toShow()
      } else {
        this.prezzo = null
      }
    }
  },
  computed: {
    dialog: {
      get() {
        return this.editing != null
      },
      set() {
        this.$emit('close')
      }
    }
  },
  /**
   * @prop editing {object} - L'oggetto da modificare
   * @prop listino {string} - Listino di riferimento
   * @prop type {string} - Tipo di prezzo da cambiare ( prod/var )
   */
  props: ['editing', 'listino', 'type']
}
</script>

<style lang="stylus" scoped>
.container
  padding: 64px 0 0 0
  height: 100vh
</style>



// WEBPACK FOOTER //
// src/components/common/MainPriceChanger.vue